<template>
    <div>
        <template v-if="field.type === 'text' && shouldBeSelect2">
            <input-select2 :name="field.name" :value="myValue" :placeholder="`填入或選擇一位${info_key}`" @input="inputUpdate"
                @change="update">
                <option v-for="(option, index) in options" :key="index" :value="option">{{ option }}</option>
            </input-select2>
        </template>
        <template v-if="field.type === 'text' && !shouldBeSelect2">
            <input-text :name="field.name" :value="myValue" @input="update" @change="update"></input-text>
        </template>
        <template v-if="field.type === 'radio'">
            <input-checkbox-group type="radio" :d-inline="true" :options="field.values" :name="field.name"
                :value="myValue" @input="update" @change="update"></input-checkbox-group>
        </template>
        <template v-if="field.type === 'checkbox'">
            <input-checkbox-group :d-inline="true" :limit="field.count" :options="field.values" :name="field.name"
                :value="myValue" @input="update" @change="update"></input-checkbox-group>
        </template>
    </div>
</template>
<script>
    import eventHub from '../../library/eventHub';

    export default {
        props: {
            field: {
                required: true
            },
            value: {
                default: undefined
            }
        },
        watch: {
            value: {
                deep: true,
                handler(newValue, oldValue) {
                    this.myValue = newValue;
                }
            }
        },
        data() {
            return {
                info_key: null,
                options: [],
                ignore: '',
                myValue: undefined
            };
        },
        mounted() {
            this.myValue = this.value;
            if (this.field.type === 'checkbox') this.myValue = [];
        },
        methods: {
            update(newValue) {
                if (!newValue && this.ignore) this.ignore = '';
                this.$emit('input', newValue);
                return;
            },
            inputUpdate(newValue) {
                if (this.shouldBeSelect2) {
                    if (newValue && !this.options.includes(newValue)) {
                        this.ignore = newValue;
                        let new_option = {};
                        new_option[this.info_key] = newValue;
                        eventHub.$emit('user-info:append', new_option);
                    } else {
                        this.ignore = '';
                    }
                }
                return this.update(newValue);
            }
        },
        computed: {
            shouldBeSelect2() {
                let userInfo = eventHub.$data.userInfo;
                if (userInfo) {
                    Object.keys(userInfo).forEach(key => {
                        if (this.field.name.indexOf(key) !== -1) {
                            this.info_key = key;
                            let temprary_options = userInfo[key];
                            this.options = temprary_options.filter(item => {
                                return item !== this.ignore;
                            });
                        }
                    });
                    if (this.info_key) return true;
                    else return false;
                }
                else return false;
            }
        }
    }
</script>
<style lang="">

</style>
